module.exports = new __parcel__URL__("poisontippedarrow.2c49b373.png").toString();